<template>
  <section id="profile" class="Profile container">
        <h2>Profile</h2>
        <div class="columns">
            <div class="column is-one-third">
                <img src="../assets/images/davarj-profile.jpg" alt="David Thomas profile picture" class="profile-image" />
            </div>
            <div class="column is-two-thirds">
                <p>David specializes in understanding the connection between his clients and their artworks, and is passionate about helping them achieve the best possible display outcome in their space.</p>
                <blockquote>I find the way people relate to art fascinating, sometimes even more so than the actual artwork itself! Whether it’s a Brett Whiteley diptych in a boardroom or framed footy jumpers in the pool room, visual art really moves people and the way you display them completes an important statement. One of Melbourne’s leading art consultants, Irving Laffner calls me the professor of art hanging. I’m happy with that.</blockquote>
                <p>David has extensive experience in the Melbourne arts industry. Upbeat and perceptive as ‘La force de l'art’, he is proud to say he:</p>

                <ul>
                    <li>Curated exhibitions for leading Australian artists and sculptors</li>
                    <li>Supports Melbourne’s vibrant emerging artist community</li>
                    <li>Has curated some of Melbourne’s most valuable corporate art collections</li>
                    <li>Works in conjunction with Melbourne’s leading galleries, designers and architects</li>
                    <li>Continues to provide exceptional art services throughout Melbourne</li>
                </ul>
            </div>
        </div>
  </section>
</template>
<script>
export default {
  name: 'Profile',
  components: {
  },
  computed: {
  },
  mounted () {
  },
  data () {
    return {
    };
  }
};
</script>
<style lang='scss' scoped>
  .Profile {
    padding: 75px 20px;
    
    .profile-image {
        width: 100%;
    }
  }
</style>
